export default __webpack_public_path__ + "static/media/スコッチ.60096084.PNG";